import React, {ReactNode} from 'react';
import styled, {css} from 'styled-components';

interface StyledDefaultInputWrapperProps {
  theme?: 'dark' | 'light';
}

const StyledDefaultInputWrapper = styled.div<StyledDefaultInputWrapperProps>`
  position: relative;

  /* Search icon */
  label > div > div {
    opacity: 1 !important;
    top: 50%;
    transform: translateY(-50%);
  }

  /* Style for the input element */
  input {
    width: 100%;
    padding: 10px 0 10px 10px;
    text-indent: 15px;
    width: 400px;
    box-shadow: none;
    @media screen and (max-width: 768px) {
      width: 320px;
    }

    ${({theme}) =>
      theme === 'dark'
        ? css`
            color: white;
            border-bottom: 1px solid #fff;
          `
        : css`
            color: black;
            border-bottom: 1px solid #000;
          `};
  }

  /* Style for the placeholder */
  input::placeholder {
    color: ${({theme}) => (theme === 'dark' ? '#999' : '#666')};
    // font-style: italic;
    box-shadow: none;
    font-size: 16px;
  }

  input:hover:not(:read-only) {
    box-shadow: none;
  }

  input:focus:not(:read-only) {
    border-width: 1px;
    transition: none;
    padding: 10px 0 10px 10px;
    box-shadow: none;
  }

  button {
    ${({theme}) =>
      theme === 'dark'
        ? css`
            color: white;
          `
        : css`
            color: black;
          `};
    right: 10px;
    svg {
      width: 14px;
      height: 14px;
    }
  }

  button:hover::before {
    background-color: transparent;
  }
`;

interface InputWrapperProps {
  children: ReactNode;
  theme?: 'dark' | 'light';
}

const DefaultInputWrapper: React.FC<InputWrapperProps> = ({
  children,
  theme = 'light',
}) => {
  return (
    <StyledDefaultInputWrapper theme={theme}>
      {children}
    </StyledDefaultInputWrapper>
  );
};

export default DefaultInputWrapper;
